module.exports = __webpack_public_path__ + "static/media/logo.7513f7d1.png";